// observeMatches – ultra-lean & fast
// Observes existing + future elements matching `selector` under `root`.
// Calls `onAdd(el)` once per element. Returns { disconnect }.
(function () {
  function observeMatches(selector, onAdd, { root = document } = {}) {
    if (typeof selector !== 'string' || typeof onAdd !== 'function')
      throw new Error('observeMatches(selector, onAdd, {root}) requires valid args.');

    const seen = new WeakSet();

    // Hot-path handler: mark once, then invoke
    function handle(el) {
      if (el && el.nodeType === 1 && !seen.has(el)) {
        seen.add(el);
        onAdd(el);
      }
    }

    // Initial pass (existing nodes)
    const initial = root.querySelectorAll ? root.querySelectorAll(selector) : [];
    for (let i = 0; i < initial.length; i++) handle(initial[i]);

    // Choose best observation target
    const target =
      root && root.nodeType === Node.DOCUMENT_NODE
        ? /** @type {Document} */(root).documentElement
        : root;

    // Observe future additions (childList only; fastest common case)
    const mo = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const added = mutations[i].addedNodes;
        for (let j = 0; j < added.length; j++) {
          const node = added[j];
          if (node.nodeType !== 1) continue; // Element only
          const el = /** @type {Element} */ (node);

          // Fast self-match
          if (el.matches && el.matches(selector)) handle(el);

          // Scan descendants (querySelectorAll is native and fast)
          if (el.querySelectorAll) {
            const found = el.querySelectorAll(selector);
            for (let k = 0; k < found.length; k++) handle(found[k]);
          }
        }
      }
    });

    mo.observe(target, { childList: true, subtree: true });

    return { disconnect() { mo.disconnect(); } };
  }

  // UMD-lite export
  if (typeof window !== 'undefined') window.observeMatches = observeMatches;
  if (typeof module !== 'undefined' && module.exports) module.exports = observeMatches;
})();